export const currencyOptions = {
    style: "currency",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};
//# sourceMappingURL=currencyOptions.js.map